// 事件管理路由
export default {
    path: 'eventManage',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: { title: '事件管理' },
    children: [{
        path: 'list',
        component: () => import('@/components/RouterView'),
        redirect: '/eventManage/list',
        meta: { title: '事件管理' },
        children: [
            {
                path: '',
                component: () => import('@/views/eventManage/list/index'),
                meta: { title: '事件管理列表' }
            },
            {
                path: 'statistic/:id',
                component: () => import('@/views/eventManage/list/statistic'),
                meta: { title: '数据统计' },
                props: true
            }
        ]
    },
    {
        path: 'conversionRate',
        component: () => import('@/components/RouterView'),
        redirect: '/eventManage/conversionRate/list',
        meta: { title: '事件转化率' },
        children: [
            {
                path: 'list',
                component: () => import('@/views/eventManage/conversionRate/list'),
                meta: { title: '事件转化率' },
            },
            {
                path: 'statistic/:id',
                component: () => import('@/views/eventManage/conversionRate/statistic'),
                meta: { title: '事件转化率-数据统计' },
                props: true
            }
        ]
    }]
}